/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoNumerazioneDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Cerca tutti tipiNumerazioneController
 * @summary Cerca tutti tipiNumerazioneController
 */
export const getTipiNumerazioneProcedimento = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoNumerazioneDTO[]>(
    {
      url: `/framework-cfg-procedimenti/tipi-numerazione-procedimento`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiNumerazioneProcedimentoQueryKey = () =>
  [`/framework-cfg-procedimenti/tipi-numerazione-procedimento`] as const;

export const getGetTipiNumerazioneProcedimentoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiNumerazioneProcedimentoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>
  > = ({ signal }) => getTipiNumerazioneProcedimento(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiNumerazioneProcedimentoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>
>;
export type GetTipiNumerazioneProcedimentoQueryError = ErrorType<unknown>;

/**
 * @summary Cerca tutti tipiNumerazioneController
 */
export const useGetTipiNumerazioneProcedimento = <
  TData = Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiNumerazioneProcedimento>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiNumerazioneProcedimentoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
